module.exports = __webpack_public_path__ + "Tinebase/js/ace-ext-keybinding_menu-FAT.js";